(() => {
  const ROTATE_MS = 4500;
  const ANIM_MS = 350;

  function prefersReducedMotion() {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  }

  function initTopbarCenterRotator(root = document) {
    const centers = root.querySelectorAll(".topbar__center");

    centers.forEach((center) => {
      if (center.dataset.rotatorInit === "1") return;

      const items = Array.from(center.querySelectorAll(".topbar__text"));
      if (items.length < 2) return;
      if (prefersReducedMotion()) return;

      center.dataset.rotatorInit = "1";

      // Measure height before absolute positioning kicks in
      const maxH = Math.max(...items.map((el) => el.offsetHeight || 0));
      if (maxH > 0) center.style.height = `${maxH}px`;

      center.classList.add("topbar__center--rotating");

      // Create nav buttons (< and >)
      const nav = document.createElement("div");
      nav.className = "topbar__nav";

      const prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = "topbar__btn topbar__btn--prev";
      prevBtn.setAttribute("aria-label", "Previous message");
      prevBtn.innerHTML = "&lsaquo;";

      const nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "topbar__btn topbar__btn--next";
      nextBtn.setAttribute("aria-label", "Next message");
      nextBtn.innerHTML = "&rsaquo;";

      nav.appendChild(prevBtn);
      nav.appendChild(nextBtn);
      center.appendChild(nav);

      // Initial state
      items.forEach((el, i) => {
        el.classList.toggle("is-active", i === 0);
        el.classList.remove("is-exiting");
      });

      let idx = 0;
      let timer = null;

      function setDirectionVars(direction) {
        // For NEXT in LTR: in from right, out to left
        // For PREV in LTR: in from left, out to right
        // (If you ever use RTL, the browser flips visual meaning anyway, but this still feels right.)
        if (direction === "prev") {
          center.style.setProperty("--topbar-slide-in", "-100%");
          center.style.setProperty("--topbar-slide-out", "100%");
        } else {
          center.style.setProperty("--topbar-slide-in", "100%");
          center.style.setProperty("--topbar-slide-out", "-100%");
        }
      }

      function show(nextIdx, direction = "next") {
        if (nextIdx === idx) return;

        setDirectionVars(direction);

        const current = items[idx];
        const next = items[nextIdx];

        current.classList.remove("is-active");
        current.classList.add("is-exiting");

        next.classList.add("is-active");

        window.setTimeout(() => current.classList.remove("is-exiting"), ANIM_MS);
        idx = nextIdx;
      }

      function next() {
        show((idx + 1) % items.length, "next");
      }

      function prev() {
        show((idx - 1 + items.length) % items.length, "prev");
      }

      function start() {
        stop();
        timer = window.setInterval(next, ROTATE_MS);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function restart() {
        start();
      }

      // Auto-rotate + pause on hover
      start();
      center.addEventListener("mouseenter", stop);
      center.addEventListener("mouseleave", start);

      // Click controls
      nextBtn.addEventListener("click", () => {
        next();
        restart();
      });

      prevBtn.addEventListener("click", () => {
        prev();
        restart();
      });

      // Keyboard: allow left/right arrows when focus is inside the center area
      center.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          next();
          restart();
        } else if (e.key === "ArrowLeft") {
          e.preventDefault();
          prev();
          restart();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initTopbarCenterRotator());
  } else {
    initTopbarCenterRotator();
  }

  // Shopify theme editor (section reloads)
  document.addEventListener("shopify:section:load", (e) => {
    initTopbarCenterRotator(e.target);
  });
})();
